<div
  role="dialog"
  cdkTrapFocus
  aria-modal="true"
  class="modal-wrapper"
  data-cy="terms_dialog"
  [cdkTrapFocusAutoCapture]="true"
  [attr.data-cy]="dialogData.dataCy"
  aria-labelledby="terms-and-conditions-title"
  [class.modal-wrapper--drawer]="!!config.drawer"
  [style.background]="config.drawer ? config.background : null"
>
  @if (config.drawer; as drawer) {
    <div class="header">
      <button
        cdkFocusInitial
        type="button"
        class="close-button"
        data-cy="close_btn"
        (click)="closeDialog()"
        [attr.aria-label]="drawer.closeButton.alternativeText"
      >
        <img alt="" [src]="drawer.closeButton.imageUrl" />
      </button>
    </div>
  }

  <h1
    class="modal-title"
    id="terms-and-conditions-title"
    [style]="{
      color: config.title.color,
      fontFamily: config.title.fontFamily,
    }"
  >
    {{ config.title.label }}
  </h1>

  @if (config.drawer; as drawer) {
    <div class="illustration">
      <img alt="" class="pentagon" [src]="drawer.illustration.pentagonUrl" />
      <img
        class="voucher"
        [src]="drawer.illustration.illustrationUrl"
        [alt]="drawer.illustration.illustrationAlt"
      />
    </div>
  }

  <p
    class="modal-body"
    [style]="{
      color: config.body.color,
      fontFamily: config.body.fontFamily,
    }"
    [innerHTML]="data | safe"
  ></p>

  @if (!config.drawer) {
    <div class="modal-footer justify-content-center">
      <b2c-button
        class="close-btn"
        data-cy="close_btn"
        (click)="closeDialog()"
        [styles]="{
          color: config.closeButton.color,
          border: config.closeButton.border,
          borderRadius: config.closeButton.borderRadius,
          backgroundColor: config.closeButton.backgroundColor,
        }"
      >
        {{ config.closeButton.label }}</b2c-button
      >
    </div>
  }
</div>
